module.exports = __webpack_public_path__ + "img/AI.218c5ea.svg";